import { Scene } from 'phaser';

export class MenuScene extends Scene {
  constructor() {
    super({ key: 'MenuScene' });
  }

  create(): void {
    const { width, height } = this.cameras.main;

    this.add.text(width / 2, height / 3, 'MINIMALISTIC', {
      fontSize: '32px',
      fontFamily: 'Courier New',
      color: '#00ffff',
      align: 'center'
    }).setOrigin(0.5);

    this.add.text(width / 2, height / 3 + 40, 'AUTO BATTLER', {
      fontSize: '24px',
      fontFamily: 'Courier New',
      color: '#ff00ff',
      align: 'center'
    }).setOrigin(0.5);

    const playButton = this.add.text(width / 2, height / 2, 'PLAY', {
      fontSize: '28px',
      fontFamily: 'Courier New',
      color: '#ffffff',
      backgroundColor: '#00ffff',
      padding: { x: 20, y: 10 }
    }).setOrigin(0.5);

    playButton.setInteractive({ useHandCursor: true });
    playButton.on('pointerdown', () => this.startGame());
    playButton.on('pointerover', () => playButton.setStyle({ color: '#00ffff' }));
    playButton.on('pointerout', () => playButton.setStyle({ color: '#ffffff' }));

    this.add.text(width / 2, height * 0.8, 'Defend your base from endless waves', {
      fontSize: '14px',
      fontFamily: 'Courier New',
      color: '#888888',
      align: 'center'
    }).setOrigin(0.5);
  }

  private startGame(): void {
    this.scene.start('GameScene');
  }
}